<template>
<div id="layouts_activo_fijo" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Agregar Identificador de Activo AF_FILE" class="elevation-1 px-5 py-3" >
                    
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="pedimentos" >Layout a nivel pedimento</v-tab>            
                        <v-tab key="partidas" >Layout a nivel partidas</v-tab>
                        
                        <v-tab-item key="pedimentos" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                            
                                   
                                    <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="LayoutAF_Pedimento.xlsx" style="position:absolute; margin-top:65px; margin-left:220px">
                                            <v-btn fab dark  color="purple darken-2" title="Descargar la Plantilla" v-tippy>
                                                <v-icon dark large>receipt</v-icon>
                                            </v-btn>
                                        </exportar-excel>    

                                        <upload-excel-component-big title="Cargar el Layout" idInput="pedimentosKey" :on-success="handleSuccess" :before-upload="beforeUpload"  style="position:absolute; margin-top:362px; margin-left:218px"/>
                                    <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/af_file_2.png" style="width:732px;" />
                                </v-card-text>
                            </div>
                        </v-tab-item>            
                        <v-tab-item key="partidas" >
                            <div class="contenedor-tab-reportes-partidas" >
                                <v-card-text >
                                  
                                    <exportar-excel :data="camposLayoutPartidas" :exportFields="encabezadoLayoutPartidas" name="LayoutAF_Partidas.xlsx" style="position:absolute; margin-top:65px; margin-left:220px">
                                            <v-btn fab dark  color="purple darken-2" title="Descargar la Plantilla" v-tippy>
                                                <v-icon dark large>receipt</v-icon>
                                            </v-btn>
                                        </exportar-excel>    

                                        <upload-excel-component-big title="Cargar el Layout"  idInput="partidasKey" :on-success="handleSuccessPartidas" :before-upload="beforeUpload"  style="position:absolute; margin-top:362px; margin-left:218px"/>
                                   
                                        
                                    <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/af_file_1.png" style="width:732px;" />
                               
                             
                             
                                    </v-card-text>
                               
                            </div>
                        </v-tab-item>

                    </v-tabs>
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from 'vue'
import UploadExcelComponentBig from '@/components/UploadExcel/UploadExcelBig.vue';

Vue.component('UploadExcelComponentBig', UploadExcelComponentBig);
export default {
    components: {                
    },

data: () => ({
        menu1: false,
        name: "datagrid",
        importData: [],
        arrClaves:[],        
        URL: "",

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Información de Contenido de Pedimentos",
                disabled: false,
                to: "/reportes/informacion_activo"
            },
            {
                text: "Interfaz de Identificación AF_FILE",
                disabled: true,
                to: "/reportes/layouts_activofijo"
            },
            {
                text: "Reporte Activo Fijo",
                disabled: false,
                to: "/reportes/activofijo"
            },            
            {
                text: "Etiquetado Código QR",
                disabled: false,
                to: "/reportes/etiquetas_activofijo"
            }
        ],
                
        //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
        //NIVEL PEDIMENTO
        encabezadoLayout: {
            pedimento: "pedimento",
            fecha_pago: "fecha_pago",
            tipo_operacion: "tipo_operacion",
            clave_documento:"clave_documento",
            identificador:"identificador",            
        },
        //van vacíos para solo descargar layout con encabezados
        camposLayout: [{
            pedimento: "[No de Pedimento. Ej. 370-3668-9000123]",
            fecha_pago: "[Fecha Pago del Pedimento]",
            tipo_operacion: "[Tipo de Operación: 1-Impo, 2-Expo]",
            clave_documento:"[Clave Documento del Pedimento]",
            identificador:"[AF_FILE (para marcar como AF) | NO_AF (descartar como AF)]",
        }],        
        camposObligatorios: [
            "pedimento",
            "fecha_pago",
            "tipo_operacion",
            "clave_documento",
            "identificador",            
        ],
        //NIVEL PARTIDAS
        encabezadoLayoutPartidas: {
            pedimento: "pedimento",
            fecha_pago: "fecha_pago",
            tipo_operacion: "tipo_operacion",
            clave_documento:"clave_documento",
            identificador:"identificador",
            no_partida:"no_partida"
        },
        //van vacíos para solo descargar layout con encabezados
        camposLayoutPartidas: [{
            pedimento: "[No de Pedimento. Ej. 370-3668-9000123]",
            fecha_pago: "[Fecha Pago del Pedimento]",
            tipo_operacion: "[Tipo de Operación: 1-Impo, 2-Expo]",
            clave_documento:"[Clave Documento del Pedimento]",            
            identificador:"[AF_FILE (para marcar partidas como AF) | NO_AF (descartar partidas como AF)]",
            no_partida:"[Número de Partida]"
        }],        
        camposObligatoriosPartidas: [
            "pedimento",
            "fecha_pago",
            "tipo_operacion",
            "clave_documento",
            "identificador",
            "no_partida"
        ],
        
    }),
    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },        
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        validaClaveDocumento(clave){
            return this.arrClaves.includes(clave);
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
                
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            //Si trae el campo no_partidas, marcamos error ya que este es para pedimento
                            if (results[k]['no_partida']!=undefined){
                                errores++;
                                errorTmp = '<br/>' + "- El archivo contiene el campo 'no_partida' el cual es exclusivo para layout de partidas, favor de verificar.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                                return ({
                                    "errores": errores,
                                    "erroresText": erroresText
                                });                                
                            }
                            
                            if(!this.validarPatronPedimento(results[k]['pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            let fechaOrig = results[k]["fecha_pago"];
                            results[k]["fecha_pago"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fecha_pago"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaEntero(results[k]['tipo_operacion'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- El Tipo Operación '" + results[k]['tipo_operacion'] + "' debe ser número entero 1 ó 2";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else if (parseInt(results[k]['tipo_operacion'])!=1 && parseInt(results[k]['tipo_operacion'])!=2) {
                                errores++;
                                errorTmp = '<br/>' + "- El Tipo Operación '" + results[k]['tipo_operacion'] + "' debe ser número entero 1 ó 2";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['tipo_operacion'] = parseInt(results[k]['tipo_operacion']);
                            }
                            
                            results[k]['clave_documento'] = results[k]['clave_documento'].toString().toUpperCase().trim();                            
                            if(!this.validaClaveDocumento(results[k]['clave_documento'])){
                                errores++;
                                errorTmp = '<br/>' + "- La clave de documento '" + results[k]['clave_documento'] + "' no existe";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if( !["AF_FILE","NO_AF"].includes(results[k]['identificador'])){
                                errores++;
                                errorTmp = '<br/>' + "- El identificador '" + results[k]['identificador'] + "' no es válido, debe ser AF_FILE ó NO_AF";                            
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }                            

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {                
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    for (var k in results) {  
                        this.importData.push({                            
                            pedimento: results[k]['pedimento'],
                            fecha_pago: results[k]['fecha_pago'],
                            tipo_operacion: results[k]['tipo_operacion'],
                            clave_documento: results[k]['clave_documento'],
                            identificador: results[k]['identificador'],                            
                        });
                    }
                    var datos = {
                        rfc: this.$local_storage.get("rfc"),                        
                        pedimentos: this.importData
                    }
                    
                    
                    axios.post(this.$hostname + "reportes_ws/layout_activo_fijo/", datos)
                    //axios.post("http://127.0.0.1:7000/reportes_ws/layout_activo_fijo/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar más tarde.",
                                footer: ""
                            });
                        }).then(() => {                            
                            this.$root.$dialogLoader.hide();
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }, 
        verificaObligatoriosPartidas: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            
            this.camposObligatoriosPartidas.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
                
        validaCargaLayoutPartidas: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatoriosPartidas(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            if(!this.validarPatronPedimento(results[k]['pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            let fechaOrig = results[k]["fecha_pago"];
                            results[k]["fecha_pago"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fecha_pago"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaEntero(results[k]['tipo_operacion'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- El Tipo Operación '" + results[k]['tipo_operacion'] + "' debe ser número entero 1 ó 2";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else if (parseInt(results[k]['tipo_operacion'])!=1 && parseInt(results[k]['tipo_operacion'])!=2) {
                                errores++;
                                errorTmp = '<br/>' + "- El Tipo Operación '" + results[k]['tipo_operacion'] + "' debe ser número entero 1 ó 2";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['tipo_operacion'] = parseInt(results[k]['tipo_operacion']);
                            }
                            
                            results[k]['clave_documento'] = results[k]['clave_documento'].toString().toUpperCase().trim();                            
                            if(!this.validaClaveDocumento(results[k]['clave_documento'])){
                                errores++;
                                errorTmp = '<br/>' + "- La clave de documento '" + results[k]['clave_documento'] + "' no existe";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if( !["AF_FILE","NO_AF"].includes(results[k]['identificador'])){
                                errores++;
                                errorTmp = '<br/>' + "- El identificador '" + results[k]['identificador'] + "' no es válido, debe ser AF_FILE ó NO_AF";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaEntero(results[k]['no_partida'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- El no_partida '" + results[k]['no_partida'] + "' debe ser un número entero válido";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccessPartidas: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {                
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayoutPartidas(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    for (var k in results) {  
                        this.importData.push({                            
                            pedimento: results[k]['pedimento'],
                            fecha_pago: results[k]['fecha_pago'],
                            tipo_operacion: results[k]['tipo_operacion'],
                            clave_documento: results[k]['clave_documento'],
                            identificador: results[k]['identificador'],
                            no_partida: results[k]['no_partida'],
                        });
                    }
                    var datos = {
                        rfc: this.$local_storage.get("rfc"),                        
                        pedimentos: this.importData
                    }
                    
                    axios.post(this.$hostname + "reportes_ws/layout_activo_fijo/", datos)
                    //axios.post("http://127.0.0.1:7000/reportes_ws/layout_activo_fijo/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar más tarde.",
                                footer: ""
                            });
                        }).then(() => {                            
                            this.$root.$dialogLoader.hide();
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }, 
        cargarClaves: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                tabla: 13 //Apendice de claves de pedimento
            };
            axios
                .post(this.$hostname + "apendices/lista/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.arrClaves = res.data.map(e => e.clave);                        
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    }, //methods

    created: function () {                
        this.cargarClaves();
    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

</style>
